import { useRef } from "react";
import useUnmount from "./useUnmount";
import usePersist from "./usePersist";
function useTimeout(callback, timeout) {
  var handler = usePersist(callback);
  var timerRef = useRef();
  var cancel = usePersist(function () {
    if (timerRef.current !== undefined) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  });
  var start = usePersist(function () {
    cancel();
    timerRef.current = setTimeout(handler, timeout);
  });
  useUnmount(cancel);
  return [start, cancel];
}
export default useTimeout;